<template>
  <div id="app">
    <router-view v-if="isInit && isRouterAlive" />
    <Init v-else/>
  </div>
</template>

<script>
// import NavBar from '@/components/NavBar'
import store from "@/vuex/store";
import { frontConfig } from "./api/config"
import Init from "./views/initialization"

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  components:{Init},
  data() {
    return {
      path: "",
      isRouterAlive: true,
      isInit: true,
      beforeUnloadTime: "",
      gapTime: ""
    };
  },
  props: {
    // reload: Function
  },
  mounted() {
    // 获取系统语言
    console.log("APP:", store.state.lang);
    this.$i18n.locale = store.state.lang;

    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
    window.addEventListener("unload", e => this.unloadHandler(e));

    frontConfig().then(res=>{
        this.isInit = res.initialized
    })
  },
  destroyed() {
    window.removeEventListener("beforeunload", e =>
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", e => this.unloadHandler(e));
  },
  created() {
    window.application = this;
    this.path = this.$route.path;

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(store.state));
    });

    //判断是否登录
    if (store.state.token == null) {
      if (
        this.path.indexOf("register") == -1 &&
        this.path.indexOf("saleService") == -1 &&
        this.path.indexOf("mobile") == -1
      ) {
        this.$router.push({
          path: `/`
        });
      }
    }
  },
  methods: {
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler(e) {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime;
      //判断是窗口关闭还是刷新
      if (this.gapTime <= 5) {
        navigator.sendBeacon(
          this.$axios.defaults.baseURL + "/login/loginOut",
          ""
        );
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    }
  }
};
</script>

<style>
#app {
  background: #eff2f7;
  min-height: 100vh;
}
/*.el-collapse-item__header {*/
/*  background-color: #00b7fa !important;*/
/*}*/
/*.el-collapse-item .el-collapse-item__content {*/
/*  background-color: #04101d !important;*/
/*}*/

.el-table {
  -ms-flex: none !important;
  flex: none !important;
  height: max-content;
}
</style>



// WEBPACK FOOTER //
// src/App.vue